import { HolidaysDto  } from "@gtpl/shared-models/gtpl";
import { GlobalResponseObject } from '@gtpl/shared-models/common-models';


export class AllSHolidaysResponseModel extends GlobalResponseObject {
    data?: HolidaysDto[];
    constructor(status: boolean, intlCode: number, internalMessage: string, data?: HolidaysDto[]){
        super(status,intlCode,internalMessage);
        this.status = status;
        this.intlCode = intlCode;
        this.internalMessage = internalMessage;
        this.data = data;
    }
}

